module.exports = __webpack_public_path__ + "0add7aae9df67ce458b9a391cc962f10.png";